// This file is the bridge that connects our server-side-rendered HTML
// to the Vue component AdminFilters.vue
//
// When UiAdmin::FiltersBar::Component is loaded, it will call this file,
// which will trigger the creation of the filtersApp

import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { i18n } from '../../../../frontend/entrypoints/i18n'
import PrimeVue from 'primevue/config';
import AdminFilters from '../../../../frontend/components/AdminFilters.vue'
import DateTimePicker from '../../../../frontend/components/DateTimePicker.vue'
import DateTimeRangePicker from '../../../../frontend/components/DateTimeRangePicker.vue'
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import GroupedMultiselect from "../../../../frontend/components/GroupedMultiselect.vue";
import Multiselect from "../../../../frontend/components/Multiselect.vue";
import { formDependenciesPlugin } from '../../../../frontend/dependencies/formDependencies'

export default class extends Controller {
  connect() {
    this.filtersApp = createApp()
    this.filtersApp
      .component('adminfilters', AdminFilters)
      .component('groupedmultiselect', GroupedMultiselect)
      .component('multiselect', Multiselect)
      .component('accordion', Accordion)
      .component('accordionpanel', AccordionPanel)
      .component('accordionheader', AccordionHeader)
      .component('accordioncontent', AccordionContent)
      .component('datetimepicker', DateTimePicker)
      .component('datetimerangepicker', DateTimeRangePicker)
    this.filtersApp.use(PrimeVue, { unstyled: true })
    this.filtersApp.use(formDependenciesPlugin)
    this.filtersApp.use(i18n)
    this.filtersApp.mount('#admin-filters')
  }

  disconnect() {
    this.filtersApp.unmount()
  }
}
